import merge from 'lodash/merge'
import mapValues from 'lodash/mapValues'
import Vue from 'vue'
import Ncs from 'ncs'
import config from '../search/ncs_config'
import documentDate from './document_date';
import ContextResult from './ContextResult'
import ContextHeader from './ContextHeader'
import KwicHeader from './KwicHeader'

const components = {
  ...Ncs.defaultComponents,
  NcsContextResult: ContextResult,
  NcsContextDocumentHeader: ContextHeader,
  NcsKwicResultHeader: KwicHeader,
}

function csvElementFields(document, text, elements, matches) {
  return mapValues({
    [this.$i18n.t('result.context.header.document.identificador')]: document.identificador,
    [this.$i18n.t('result.context.header.document.data_desde')]: documentDate(document).join(' '),
    [this.$i18n.t('result.context.header.document.procedencia')]: document.procedencia || '',
    [this.$i18n.t('result.context.header.document.paxinas')]: (document.paxina_inicio || '') + '-' + (document.paxina_fin || ''),
    [this.$i18n.t('result.context.header.document.outorgante')]: document.outorgante || '',
    [this.$i18n.t('result.context.header.document.soporte')]: document.soporte || '',
    [this.$i18n.t('result.context.header.document.unidade_arquivistica')]: document.unidade_arquivistica || '',
    [this.$i18n.t('result.context.header.document.folios')]: (document.folios_inicio || '') + '-' + (document.folios_fin || ''),
    [this.$i18n.t('result.context.header.document.tipo_rexistro')]: document.tipo_rexistro || '',
    [this.$i18n.t('result.context.header.document.numero_rexistro')]: document.numero_rexistro || '',
    [this.$i18n.t('result.context.header.document.volume')]: document.volume || '',
    [this.$i18n.t('result.context.header.document.numero_documento_edicion')]: document.numero_documento_edicion || '',
  }, v => v ? v : '')
}

// Add date format to Vue prototype to be able to use it easily from components
Vue.prototype.$documentDate = documentDate

Vue.use(Ncs, {config: merge(gon.config, config), components, csvElementFields})

export {Vue, Ncs}
